import { useState } from 'react';
import { api, ApiError } from '../lib/api.js';
import { saveStaff, type StaffSession } from '../lib/session.js';
import { Screen, Button, Card, Banner } from '../components/ui.js';

export function StaffLogin({ onIn }: { onIn: (s: StaffSession) => void }) {
  const [pin, setPin] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      // The PIN is enough: the server works out which event it belongs to.
      const res = await api<{
        token: string;
        eventId: string;
        staff: { displayName: string; role: 'HOST' | 'MANAGER' };
      }>('/api/staff/login', { method: 'POST', body: { pin } });
      const session: StaffSession = {
        token: res.token,
        displayName: res.staff.displayName,
        role: res.staff.role,
        eventId: res.eventId,
      };
      saveStaff(session);
      onIn(session);
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Could not sign in.');
      setBusy(false);
    }
  }

  return (
    <Screen>
      <form onSubmit={submit} className="mt-12 space-y-4">
        <h1 className="text-center text-2xl font-bold">Staff sign in</h1>
        <Card>
          <label htmlFor="pin" className="text-xs uppercase tracking-wide text-muted">
            Your PIN
          </label>
          <input
            id="pin"
            value={pin}
            onChange={(e) => setPin(e.target.value.replace(/\D/g, '').slice(0, 8))}
            inputMode="numeric"
            autoComplete="off"
            className="mt-2 w-full bg-transparent text-center font-mono text-4xl tracking-[0.3em] outline-none"
            placeholder="••••"
          />
        </Card>
        {error && <Banner kind="error">{error}</Banner>}
        <Button type="submit" disabled={pin.length < 4 || busy}>
          {busy ? 'Signing in…' : 'Sign in'}
        </Button>
        <p className="text-center text-xs text-muted">
          Your PIN identifies you personally, so the audit log can say who did what.
        </p>
      </form>
    </Screen>
  );
}
